import { render, staticRenderFns } from "./LinkedContentPopin.vue?vue&type=template&id=f8a8fb6e&scoped=true"
import script from "./LinkedContentPopin.vue?vue&type=script&lang=js"
export * from "./LinkedContentPopin.vue?vue&type=script&lang=js"
import style0 from "./LinkedContentPopin.vue?vue&type=style&index=0&id=f8a8fb6e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a8fb6e",
  null
  
)

export default component.exports